<template>
  <Label
    v-if="label"
    :for="id"
    class="mb-2 ml-1 block w-full text-left text-[0.7rem] font-black tracking-[0.15em] text-text-weak-dark/60"
    :class="computedLabelClasses"
  >
    {{ label }}
    <span v-if="required" class="ml-1 text-brand text-lg select-none">*</span>
  </Label>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { Label } from "@/components/ui/label";

interface Props {
  label?: string;
  required?: boolean;
  id?: string;
  labelClassName?: string;
}

const props = withDefaults(defineProps<Props>(), {
  label: "",
  required: false,
  id: "",
  labelClassName: "",
});

const computedLabelClasses = computed(() => [props.labelClassName]);
</script>
